import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { YourMistr } from './pages/YourMistr';
import { SelfBuildingWebsite } from './pages/SelfBuildingWebsite';
import { ProjectManager } from './pages/ProjectManager';
import { SelfManagingCrm } from './pages/SelfManagingCrm';
import { LiveMindMaps } from './pages/LiveMindMaps';
import { SelfMarketing } from './pages/SelfMarketing';
import { OnboardingAgents } from './pages/OnboardingAgents';
import { PersonaBuilder } from './pages/PersonaBuilder';
import { DedicatedLine } from './pages/DedicatedLine';
import { VoiceAgents } from './pages/VoiceAgents';
import { ReputationManager } from './pages/ReputationManager';
import { DocumentGenerator } from './pages/DocumentGenerator';
import { Contact } from './pages/Contact';
import { Partners } from './pages/Partners';
import { Community } from './pages/Community';
import { Blog } from './pages/Blog';
import { CaseStudies } from './pages/CaseStudies';
import { Security } from './pages/Security';
import { Enterprise } from './pages/Enterprise';
import { FeaturesHub } from './pages/FeaturesHub';
import { Integrations } from './pages/Integrations';
import { AdvancedAnalytics } from './pages/AdvancedAnalytics';
import { VsIndex } from './pages/VsIndex';
import { VsLindy } from './pages/VsLindy';
import { VsZapier } from './pages/VsZapier';
import { VsHubspot } from './pages/VsHubspot';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { MeetMr } from './pages/MeetMr';
import { BusinessDeepDive } from './pages/BusinessDeepDive';
import { IntakeUpload } from './pages/IntakeUpload';
import { BrandPersona } from './pages/BrandPersona';
import { CreateAgents } from './pages/CreateAgents';
import { ReviewProcess } from './pages/ReviewProcess';
import { RevampRepeat } from './pages/RevampRepeat';
import { TeamOfTwenty } from './pages/TeamOfTwenty';
import { AutopilotMarketing } from './pages/AutopilotMarketing';
import { Pricing } from './pages/Pricing';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-dark-bg text-white font-inter selection:bg-purple/30 selection:text-white" data-id="element-1">
        <Nav data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/pricing" element={<Pricing data-id="element-7" />} data-id="element-6" />

          {/* How It Works Flow */}
          <Route path="/how-it-works" element={<HowItWorksPage data-id="element-9" />} data-id="element-8" />
          <Route path="/how-it-works/meet-mr" element={<MeetMr data-id="element-11" />} data-id="element-10" />
          <Route path="/how-it-works/business-deep-dive" element={<BusinessDeepDive data-id="element-13" />} data-id="element-12" />
          <Route path="/how-it-works/intake-upload" element={<IntakeUpload data-id="element-15" />} data-id="element-14" />
          <Route path="/how-it-works/brand-persona" element={<BrandPersona data-id="element-17" />} data-id="element-16" />
          <Route path="/how-it-works/create-agents" element={<CreateAgents data-id="element-19" />} data-id="element-18" />
          <Route path="/how-it-works/review-process" element={<ReviewProcess data-id="element-21" />} data-id="element-20" />
          <Route path="/how-it-works/revamp-repeat" element={<RevampRepeat data-id="element-23" />} data-id="element-22" />

          {/* Legacy / Moved Routes */}
          <Route path="/your-mistr" element={<YourMistr data-id="element-25" />} data-id="element-24" />

          {/* Features & Solutions */}
          <Route path="/team-of-20" element={<TeamOfTwenty data-id="element-27" />} data-id="element-26" />
          <Route path="/self-building-website" element={<SelfBuildingWebsite data-id="element-29" />} data-id="element-28" />
          <Route path="/project-manager" element={<ProjectManager data-id="element-31" />} data-id="element-30" />
          <Route path="/self-managing-crm" element={<SelfManagingCrm data-id="element-33" />} data-id="element-32" />
          <Route path="/live-mind-maps" element={<LiveMindMaps data-id="element-35" />} data-id="element-34" />
          <Route path="/self-marketing" element={<SelfMarketing data-id="element-37" />} data-id="element-36" />
          <Route path="/self-running-marketing" element={<AutopilotMarketing data-id="element-39" />} data-id="element-38" />
          <Route path="/onboarding-agents" element={<OnboardingAgents data-id="element-41" />} data-id="element-40" />
          <Route path="/persona-builder" element={<PersonaBuilder data-id="element-43" />} data-id="element-42" />
          <Route path="/dedicated-line" element={<DedicatedLine data-id="element-45" />} data-id="element-44" />
          <Route path="/voice-agents" element={<VoiceAgents data-id="element-47" />} data-id="element-46" />
          <Route path="/reputation-manager" element={<ReputationManager data-id="element-49" />} data-id="element-48" />
          <Route path="/document-generator" element={<DocumentGenerator data-id="element-51" />} data-id="element-50" />

          {/* Company & Resources */}
          <Route path="/contact" element={<Contact data-id="element-53" />} data-id="element-52" />
          <Route path="/partners" element={<Partners data-id="element-55" />} data-id="element-54" />
          <Route path="/community" element={<Community data-id="element-57" />} data-id="element-56" />
          <Route path="/blog" element={<Blog data-id="element-59" />} data-id="element-58" />
          <Route path="/case-studies" element={<CaseStudies data-id="element-61" />} data-id="element-60" />
          <Route path="/security" element={<Security data-id="element-63" />} data-id="element-62" />
          <Route path="/enterprise" element={<Enterprise data-id="element-65" />} data-id="element-64" />
          <Route path="/features" element={<FeaturesHub data-id="element-67" />} data-id="element-66" />
          <Route path="/integrations" element={<Integrations data-id="element-69" />} data-id="element-68" />
          <Route path="/advanced-analytics" element={<AdvancedAnalytics data-id="element-71" />} data-id="element-70" />

          {/* VS Pages */}
          <Route path="/vs" element={<VsIndex data-id="element-73" />} data-id="element-72" />
          <Route path="/vs/lindy-ai" element={<VsLindy data-id="element-75" />} data-id="element-74" />
          <Route path="/vs/zapier" element={<VsZapier data-id="element-77" />} data-id="element-76" />
          <Route path="/vs/hubspot" element={<VsHubspot data-id="element-79" />} data-id="element-78" />
        </Routes>
        <Footer data-id="element-80" />
      </div>
    </BrowserRouter>;
}